import { Skeleton, styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export const PaperSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
}));

interface LoadingProps {
  width?: number;
  height?: number;
  topPercent?: number;
  leftPercent?: number;
}

class LoadingComponent extends React.Component<LoadingProps> {
  public render(): React.JSX.Element {
    let { width, height, topPercent, leftPercent } = this.props;

    if (!width) {
      width = 150;
    }

    if (!height) {
      height = 150;
    }

    if (!topPercent) {
      topPercent = 50;
    }

    if (!leftPercent) {
      leftPercent = 50;
    }

    return (
      <CircularProgress
        style={{
          position: 'absolute',
          width,
          height,
          marginTop: (height / 2) * -1,
          marginLeft: (width / 2) * -1,
          top: topPercent + '%',
          left: leftPercent + '%',
        }}
      />
    );
  }
}

export const Loading = LoadingComponent;
